import { call, put, takeEvery } from "redux-saga/effects";
import {
  dotDangKyChuyenNganhApi,
  ketQuaXetChuyenNganhApi,
  sinhVienDangKyChuyenNganhApi,
  thietLapDotDangKyChuyenNganhApi,
} from "../../../api/dang-ky-chuyen-nganh/dotDangKyChuyenNganhApi";
import { IDotDangKyChuyenNganh } from "../../../model/respone/dang-ky-chuyen-nganh/IDotDangKyChuyenNganh";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDangKyChuyenNganhActionIds,
  IDangKyChuyenNganhActionTypes,
} from "../../action-types/dang-ky-chuyen-nganh/IDangKyChuyenNganhActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.dangKyChuyenNganh.dangKyChuyenNganh;

export function* dangKyChuyenNganhSaga(): any {
  yield takeEvery(eDangKyChuyenNganhActionIds.LOAD_DOTS_START, loadDotsWorker);
  yield takeEvery(eDangKyChuyenNganhActionIds.SAVE_DOT_START, saveDotWorker);
  yield takeEvery(eDangKyChuyenNganhActionIds.DELETE_DOT_START, deleteDotWorker);

  yield takeEvery(eDangKyChuyenNganhActionIds.LOAD_THIET_LAPS_START, loadThietLapsWorker);
  yield takeEvery(eDangKyChuyenNganhActionIds.SUBMIT_THIET_LAPS_START, submitThietLapsWorker);

  yield takeEvery(eDangKyChuyenNganhActionIds.LOAD_SINH_VIENS_START, loadSinhViensWorker);
  yield takeEvery(eDangKyChuyenNganhActionIds.SUBMIT_NGUYEN_VONG_START, submitNguyenVongWorker);
  yield takeEvery(eDangKyChuyenNganhActionIds.DELETE_KET_QUA_DANG_KY_START, deleteKetQuaDangKyWorker);

  yield takeEvery(eDangKyChuyenNganhActionIds.LOAD_KET_QUAS_START, loadKetQuasWorker);
  yield takeEvery(eDangKyChuyenNganhActionIds.XET_TU_DONG_START, xetTuDongWorker);
}

function* loadDotsWorker(): any {
  const res: IBaseRespone = yield call(dotDangKyChuyenNganhApi.SelectAll);
  if (res.is_success) yield put(mainAction.LOAD_DOTS_SUCCESS(res.data));
  else yield put(mainAction.LOAD_DOTS_ERRR(res.message ?? "Có lỗi"));
}

function* saveDotWorker(action: IDangKyChuyenNganhActionTypes): any {
  const payload = action.payload as IDotDangKyChuyenNganh;
  const res: IBaseRespone =
    payload.id > 0
      ? yield call(dotDangKyChuyenNganhApi.Update, payload)
      : yield call(dotDangKyChuyenNganhApi.Insert, payload);
  if (res.is_success) yield put(mainAction.SAVE_DOT_SUCCESS(res.data));
  else yield put(mainAction.SAVE_DOT_ERRR(res.message ?? "Có lỗi"));
}

function* deleteDotWorker(action: IDangKyChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(dotDangKyChuyenNganhApi.Delete, action.payload as number);
  if (res.is_success) yield put(mainAction.DELETE_DOT_SUCCESS(res.data));
  else yield put(mainAction.DELETE_DOT_ERRR(res.message ?? "Có lỗi"));
}

function* loadThietLapsWorker(action: IDangKyChuyenNganhActionTypes): any {
  const dotId = action.payload as number;
  if (!dotId) return;
  const res: IBaseRespone = yield call(thietLapDotDangKyChuyenNganhApi.SelectByDot, dotId);
  if (res.is_success) yield put(mainAction.LOAD_THIET_LAPS_SUCCESS(res.data));
  else yield put(mainAction.LOAD_THIET_LAPS_ERRR(res.message ?? "Có lỗi"));
}

function* submitThietLapsWorker(action: IDangKyChuyenNganhActionTypes): any {
  const { dotId, data } = action.payload as { dotId: number; data: any[] };
  const res: IBaseRespone = yield call(thietLapDotDangKyChuyenNganhApi.Submit, dotId, data);
  if (res.is_success) yield put(mainAction.SUBMIT_THIET_LAPS_SUCCESS(res.data));
  else yield put(mainAction.SUBMIT_THIET_LAPS_ERRR(res.message ?? "Có lỗi"));
}

function* loadSinhViensWorker(action: IDangKyChuyenNganhActionTypes): any {
  const dotId = action.payload as number;
  if (!dotId) return;
  const res: IBaseRespone = yield call(sinhVienDangKyChuyenNganhApi.SelectByDot, dotId);
  if (res.is_success) yield put(mainAction.LOAD_SINH_VIENS_SUCCESS(res.data));
  else yield put(mainAction.LOAD_SINH_VIENS_ERRR(res.message ?? "Có lỗi"));
}

function* submitNguyenVongWorker(action: IDangKyChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(
    sinhVienDangKyChuyenNganhApi.SubmitNguyenVong,
    action.payload as any
  );
  if (res.is_success) yield put(mainAction.SUBMIT_NGUYEN_VONG_SUCCESS(res.data));
  else yield put(mainAction.SUBMIT_NGUYEN_VONG_ERRR(res.message ?? "Có lỗi"));
}

function* deleteKetQuaDangKyWorker(action: IDangKyChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(
    sinhVienDangKyChuyenNganhApi.DeleteKetQuaDangKy,
    action.payload as any
  );
  if (res.is_success) yield put(mainAction.DELETE_KET_QUA_DANG_KY_SUCCESS(res.data));
  else yield put(mainAction.DELETE_KET_QUA_DANG_KY_ERRR(res.message ?? "Có lỗi"));
}

function* loadKetQuasWorker(action: IDangKyChuyenNganhActionTypes): any {
  const dotId = action.payload as number;
  if (!dotId) return;
  const res: IBaseRespone = yield call(ketQuaXetChuyenNganhApi.SelectByDot, dotId);
  if (res.is_success) yield put(mainAction.LOAD_KET_QUAS_SUCCESS(res.data));
  else yield put(mainAction.LOAD_KET_QUAS_ERRR(res.message ?? "Có lỗi"));
}

function* xetTuDongWorker(action: IDangKyChuyenNganhActionTypes): any {
  const dotId = action.payload as number;
  const res: IBaseRespone = yield call(ketQuaXetChuyenNganhApi.XetTuDong, dotId);
  if (res.is_success) yield put(mainAction.XET_TU_DONG_SUCCESS(res.data));
  else yield put(mainAction.XET_TU_DONG_ERRR(res.message ?? "Có lỗi"));
}
